import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--cta",
  "use": "icon-arrow--cta-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-arrow--cta\"><path d=\"m4.23 11.285 13.48-.006-6.125-6.125 1.027-1.027L20.485 12l-7.873 7.873-1.027-1.027 6.125-6.125-13.48-.006v-1.43Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol